import styled from "styled-components";

export const IconButton = styled.button`
  background: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  cursor: pointer;
  height: fit-content;
  border-radius: 50%;
  padding: 0.2rem;

  :hover {
    background-color: rgba(0, 0, 0, 0.04);
  }
`;
